import type { NavItemConfig, NavItemConfigInternal } from '../../types';
import { getMenuIds } from '../get-menu-ids';
import { partitionByReorderable } from '../partition-by-reorderable';

export const getMenuIdsByReorderable = (items: Record<string, Partial<NavItemConfigInternal>>) => {
	const transformedItems = Object.entries(items).map(([key, value]) => {
		return {
			menuId: key,
			...(value as NavItemConfig),
			// Default to true if isReorderable is undefined
			isReorderable: value.isReorderable ?? true,
		};
	});

	return partitionByReorderable(transformedItems).map(getMenuIds) as [string[], string[]];
};
